// extracted by mini-css-extract-plugin
export default {"imgcontainer":"HeroImage_imgcontainer__uSr5p","imgbackground":"HeroImage_imgbackground__7r7Hp","img":"HeroImage_img__sA+aZ"};